import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-arrow-down" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "categories-roll-down"
}
const _hoisted_4 = { class: "container header-padding-compensation" }
const _hoisted_5 = { class: "categories-roll-down-container" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-5 col-lg-4" }
const _hoisted_8 = {
  key: 0,
  class: "categories-roll-down-list"
}
const _hoisted_9 = {
  key: 1,
  class: "categories-roll-down-list placeholder-glow"
}
const _hoisted_10 = { class: "col-md-7 col-lg-8" }
const _hoisted_11 = { class: "advantages-section" }
const _hoisted_12 = { class: "advantage-section" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-checkmark" }, null, -1)
const _hoisted_14 = { class: "advantage-text" }
const _hoisted_15 = { class: "advantage-section" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-checkmark" }, null, -1)
const _hoisted_17 = { class: "advantage-text" }
const _hoisted_18 = { class: "advantage-section" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-checkmark" }, null, -1)
const _hoisted_20 = { class: "advantage-text" }
const _hoisted_21 = { class: "image-container" }
const _hoisted_22 = ["srcset"]
const _hoisted_23 = ["srcset"]
const _hoisted_24 = ["srcset"]
const _hoisted_25 = ["srcset"]
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = {
  class: "header-vertical",
  id: "header"
}
const _hoisted_28 = ["srcset"]
const _hoisted_29 = ["srcset"]
const _hoisted_30 = ["srcset"]
const _hoisted_31 = ["srcset"]
const _hoisted_32 = ["src", "alt"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "ico menu-icon icon-navbar" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "line" }),
    /*#__PURE__*/_createElementVNode("div", { class: "line" }),
    /*#__PURE__*/_createElementVNode("div", { class: "line" })
  ])
], -1)
const _hoisted_34 = { class: "navbar-item" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "ico ico-enter icon-navbar" }, null, -1)
const _hoisted_36 = { class: "username-avatar" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-person icon-navbar" }, null, -1)
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "customer-name" }
const _hoisted_40 = { class: "navbar-item" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "ico ico-present icon-navbar" }, null, -1)
const _hoisted_42 = { class: "navbar-link-label" }
const _hoisted_43 = { class: "navbar-item" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "ico ico-person-plus icon-navbar" }, null, -1)
const _hoisted_45 = { class: "navbar-link-label" }
const _hoisted_46 = { class: "navbar-item" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "ico ico-update icon-navbar" }, null, -1)
const _hoisted_48 = { class: "navbar-link-label" }
const _hoisted_49 = {
  key: 0,
  class: "vertical-menu"
}
const _hoisted_50 = { class: "vertical-top-container" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-telephone" }, null, -1)
const _hoisted_52 = { class: "top-link-label" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-bell-small" }, null, -1)
const _hoisted_54 = { class: "top-link-label" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-arrow-right" }, null, -1)
const _hoisted_56 = { class: "categories-list" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-arrow-right" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-arrow-right" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-arrow-right" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-arrow-right" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"100px"} }, null, -1)
const _hoisted_62 = {
  key: 0,
  class: "vertical-menu"
}
const _hoisted_63 = { class: "vertical-top-container" }
const _hoisted_64 = { class: "username-avatar" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-person" }, null, -1)
const _hoisted_66 = ["src"]
const _hoisted_67 = { class: "customer-name ms-2" }
const _hoisted_68 = { class: "mypage-list" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { class: "d-flex align-items-center" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-arrow-right" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-arrow-right" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-arrow-right" }, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-arrow-right" }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-arrow-right" }, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-arrow-right" }, null, -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-arrow-right" }, null, -1)
const _hoisted_78 = { class: "d-flex align-items-center" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-exit" }, null, -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("i", { class: "ico ico-arrow-right" }, null, -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", null, "Admin pages", -1)
const _hoisted_82 = { class: "vertical-menu-list d-none d-sm-block" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"100px"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_nav_item = _resolveComponent("b-nav-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_placeholder = _resolveComponent("b-placeholder")!
  const _component_b_navbar_nav = _resolveComponent("b-navbar-nav")!
  const _component_b_navbar = _resolveComponent("b-navbar")!
  const _component_b_collapse = _resolveComponent("b-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "header-horizontal",
      onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
    }, [
      _createVNode(_component_b_navbar, {
        id: "navbar",
        toggleable: "lg",
        type: "light",
        fixed: "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_navbar_nav, { class: "m-auto main-menu d-none d-sm-flex flex-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_nav_item, {
                class: "menu-item",
                to: {name: 'Catalog'},
                href: _ctx.$t('Pages.Catalog.path')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('website.catalog')), 1)
                ], undefined, true),
                _: 1
              }, 8, ["href"]),
              _createElementVNode("div", {
                onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.categoriesDropdownVisible = true)),
                onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.categoriesDropdownVisible = false)),
                class: "categories-item"
              }, [
                _createVNode(_component_router_link, {
                  class: "categories-link",
                  to: {name: 'CategoryCatalog'},
                  href: _ctx.$t('Pages.CategoryCatalog.path')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.categoriesDropdownVisible = false)),
                      class: "categories-item-text"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('website.categories')), 1),
                      _hoisted_2
                    ])
                  ], undefined, true),
                  _: 1
                }, 8, ["href"]),
                _createVNode(_Transition, { name: "fade-top-dropdown" }, {
                  default: _withCtx(() => [
                    (_ctx.categoriesDropdownVisible)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                  (_ctx.ready)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CategoryList, (category) => {
                                          return (_openBlock(), _createElementBlock("li", null, [
                                            _createVNode(_component_router_link, {
                                              class: "category-link",
                                              to: _ctx.getCategoryPageRouterOptions(category)
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", {
                                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.categoriesDropdownVisible = false)),
                                                  class: "category-name"
                                                }, _toDisplayString(category.ShortName), 1)
                                              ], undefined, true),
                                              _: 2
                                            }, 1032, ["to"])
                                          ]))
                                        }), 256))
                                      ]))
                                    : (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "55%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "75%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "65%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "85%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "55%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "75%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "65%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "85%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "55%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "75%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "65%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "85%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "55%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "75%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "65%",
                                            style: {"height":"15px"}
                                          })
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createVNode(_component_b_placeholder, {
                                            class: "placeholder",
                                            width: "85%",
                                            style: {"height":"15px"}
                                          })
                                        ])
                                      ]))
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                      _hoisted_13,
                                      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('website.usp-1')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                      _hoisted_16,
                                      _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('website.usp-2')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                      _hoisted_19,
                                      _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('website.usp-3')), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("picture", null, [
                                  _createElementVNode("source", {
                                    media: "only screen and (min-width: 1200px)",
                                    srcset: _ctx.$imgix('img/subscribe_with_logo_flip.png?w=266&h=370&auto=compress,format&fit=crop')
                                  }, null, 8, _hoisted_22),
                                  _createElementVNode("source", {
                                    media: "only screen and (min-width: 992px)",
                                    srcset: _ctx.$imgix('img/subscribe_with_logo_flip.png?w=266&h=370&auto=compress,format&fit=crop')
                                  }, null, 8, _hoisted_23),
                                  _createElementVNode("source", {
                                    media: "only screen and (min-width: 768px)",
                                    srcset: _ctx.$imgix('img/subscribe_with_logo_flip.png?w=266&h=370&auto=compress,format&fit=crop')
                                  }, null, 8, _hoisted_24),
                                  _createElementVNode("source", {
                                    media: "only screen and (min-width: 576px)",
                                    srcset: _ctx.$imgix('img/subscribe_with_logo_flip.png?w=266&h=370&auto=compress,format&fit=crop')
                                  }, null, 8, _hoisted_25),
                                  _createElementVNode("img", {
                                    src: _ctx.$imgix('img/subscribe_with_logo_flip.png?w=266&h=370&auto=compress,format&fit=crop'),
                                    alt: _ctx.$t('website.categories')
                                  }, null, 8, _hoisted_26)
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], undefined, true),
                  _: 1
                })
              ], 32),
              _createVNode(_component_b_nav_item, {
                class: "menu-item",
                to: {name: 'PartnerCatalogPage'},
                href: _ctx.$t('Pages.PartnerCatalogPage.path')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('website.our-partners')), 1)
                ], undefined, true),
                _: 1
              }, 8, ["href"])
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      })
    ], 32),
    _createElementVNode("div", _hoisted_27, [
      _createVNode(_component_router_link, {
        class: "navbar-brand-logo",
        to: {name: 'FrontPage'},
        href: _ctx.$t('Pages.FrontPage.path')
      }, {
        default: _withCtx(() => [
          _createElementVNode("picture", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.scrollToTop()))
          }, [
            _createElementVNode("source", {
              media: "only screen and (min-width: 1200px)",
              srcset: _ctx.$imgix('img/suubz_logo_vertical.svg?w=60&h=36&auto=compress,format&fit=crop')
            }, null, 8, _hoisted_28),
            _createElementVNode("source", {
              media: "only screen and (min-width: 992px)",
              srcset: _ctx.$imgix('img/suubz_logo_vertical.svg?w=60&h=36&auto=compress,format&fit=crop')
            }, null, 8, _hoisted_29),
            _createElementVNode("source", {
              media: "only screen and (min-width: 768px)",
              srcset: _ctx.$imgix('img/suubz_logo_vertical.svg?w=60&h=36&auto=compress,format&fit=crop')
            }, null, 8, _hoisted_30),
            _createElementVNode("source", {
              media: "only screen and (min-width: 576px)",
              srcset: _ctx.$imgix('img/suubz_logo_vertical.svg?w=60&h=36&auto=compress,format&fit=crop')
            }, null, 8, _hoisted_31),
            _createElementVNode("img", {
              class: "logo-suubz",
              src: _ctx.$imgix('img/suubz_logo_vertical.svg?w=60&h=36&auto=compress,format&fit=crop'),
              alt: _ctx.$t('website.logo'),
              width: "121",
              height: "26"
            }, null, 8, _hoisted_32)
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('website.homepage')), 1)
        ], undefined, true),
        _: 1
      }, 8, ["href"]),
      _createElementVNode("div", {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showMenuSidebar = !_ctx.showMenuSidebar, _ctx.showAccountSidebar = false)),
        class: _normalizeClass([{ 'active': _ctx.showMenuSidebar }, "navbar-item"])
      }, [
        _hoisted_33,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('general.menu')), 1)
      ], 2),
      (!_ctx.$isAuthorized)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([{ 'd-none': _ctx.showLogin }, "navbar-link"]),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToRouterLink('Login')))
          }, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('website.sign-in')), 1)
            ])
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.$isAuthorized == true)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["navbar-item", { 'active': _ctx.showAccountSidebar }]),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showAccountSidebar = !_ctx.showAccountSidebar, _ctx.showMenuSidebar = false))
          }, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("img", {
                src: _ctx.customerPhoto,
                alt: ""
              }, null, 8, _hoisted_38)
            ]),
            _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.customerName), 1)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.$isAuthorized == true)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "navbar-link",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toMyPageWithHash('#Invitérvenner')))
          }, [
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t('website.invite-friends')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.$isAuthorized)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass([{ 'd-none': _ctx.showCreateUser }, "navbar-link"]),
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToRouterLink('CreateUser')))
          }, [
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.$t('general.create-account')), 1)
            ])
          ], 2))
        : _createCommentVNode("", true),
      (!_ctx.$store.state.ActiveConnectionToBank && _ctx.ready && _ctx.$isAuthorized == true)
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: "navbar-link",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.ConnectBankAccounts()))
          }, [
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t('website.import-subscriptions')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "slide-vertical-menu" }, {
      default: _withCtx(() => [
        (_ctx.showMenuSidebar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.toContactInfo && _ctx.toContactInfo(...args))),
                    class: "top-link"
                  }, [
                    _hoisted_51,
                    _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t('website.contact-us')), 1)
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.toMyPageWithHash('#OtherSubscriptions'))),
                    class: "top-link"
                  }, [
                    _hoisted_53,
                    _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.$t('website.my-subscriptions')), 1)
                  ])
                ]),
                _createElementVNode("i", {
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showMenuSidebar = false)),
                  class: "ico ico-cross"
                })
              ]),
              _createVNode(_component_router_link, {
                class: "menu-item",
                to: {name: 'Catalog'},
                href: _ctx.$t('Pages.Catalog.path')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.goToRouterLink('Catalog')))
                  }, _toDisplayString(_ctx.$t('website.catalog')), 1),
                  _hoisted_55
                ], undefined, true),
                _: 1
              }, 8, ["href"]),
              _createElementVNode("div", {
                class: _normalizeClass(["menu-item categories", { 'white-border': _ctx.categoriesCollapseVisible }]),
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.categoriesCollapseVisible = !_ctx.categoriesCollapseVisible))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('website.categories')), 1),
                _createElementVNode("i", {
                  class: _normalizeClass(["ico", { 'ico-arrow-down': !_ctx.categoriesCollapseVisible, 'ico-arrow-up': _ctx.categoriesCollapseVisible }])
                }, null, 2)
              ], 2),
              _createVNode(_component_b_collapse, { visible: _ctx.categoriesCollapseVisible }, {
                default: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_56, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CategoryList, (category) => {
                      return (_openBlock(), _createElementBlock("li", null, [
                        _createVNode(_component_router_link, {
                          class: "category-link",
                          to: _ctx.getCategoryPageRouterOptions(category)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: "category-name",
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showMenuSidebar = false))
                            }, _toDisplayString(category.ShortName), 1)
                          ], undefined, true),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 256))
                  ])
                ], undefined, true),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_router_link, {
                class: "menu-item",
                to: {name: 'PartnerCatalogPage'},
                href: _ctx.$t('Pages.PartnerCatalogPage.path')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.goToRouterLink('PartnerCatalogPage')))
                  }, _toDisplayString(_ctx.$t('website.our-partners')), 1),
                  _hoisted_57
                ], undefined, true),
                _: 1
              }, 8, ["href"]),
              _createVNode(_component_router_link, {
                class: "menu-item",
                to: {name: 'GiftCertificate'},
                href: _ctx.$t('Pages.GiftCertificate.path')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.goToRouterLink('GiftCertificate')))
                  }, _toDisplayString(_ctx.$t('website.gift-card')), 1),
                  _hoisted_58
                ], undefined, true),
                _: 1
              }, 8, ["href"]),
              _createVNode(_component_router_link, {
                class: "menu-item",
                to: {name: 'AboutUs'},
                href: _ctx.$t('Pages.AboutUs.path')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.goToRouterLink('AboutUs')))
                  }, _toDisplayString(_ctx.$t('website.about-us')), 1),
                  _hoisted_59
                ], undefined, true),
                _: 1
              }, 8, ["href"]),
              _createVNode(_component_router_link, {
                class: "menu-item",
                to: {name: 'FAQ'},
                href: _ctx.$t('Pages.FAQ.path')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.goToRouterLink('FAQ')))
                  }, _toDisplayString(_ctx.$t('website.faq')), 1),
                  _hoisted_60
                ], undefined, true),
                _: 1
              }, 8, ["href"]),
              _hoisted_61,
              _createElementVNode("div", {
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showMenuSidebar = false)),
                class: "overlay-sidebar"
              })
            ]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-vertical-menu" }, {
      default: _withCtx(() => [
        (_ctx.showAccountSidebar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", {
                  class: "username-container",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.goToRouterLink('MyPage')))
                }, [
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _createElementVNode("img", {
                      src: _ctx.customerPhoto,
                      alt: ""
                    }, null, 8, _hoisted_66)
                  ]),
                  _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.customerName), 1)
                ]),
                _createElementVNode("i", {
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showAccountSidebar = false)),
                  class: "ico ico-cross"
                })
              ]),
              (_ctx.$isAuthorized)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["menu-item", { 'white-border': _ctx.myPageCollapseVisible }]),
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.myPageCollapseVisible = !_ctx.myPageCollapseVisible))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('website.my-page')), 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(["ico", { 'ico-arrow-down': !_ctx.myPageCollapseVisible, 'ico-arrow-up': _ctx.myPageCollapseVisible }])
                    }, null, 2)
                  ], 2))
                : _createCommentVNode("", true),
              _createVNode(_component_b_collapse, { visible: _ctx.myPageCollapseVisible }, {
                default: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_68, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        class: "mypage-link",
                        to: { name: 'MyPage', hash: '#Abonnementer' }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: "mypage-link-name",
                            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showAccountSidebar = false))
                          }, _toDisplayString(_ctx.$t('website.ourproducts')), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        class: "mypage-link",
                        to: { name: 'MyPage', hash: '#Konto' }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: "mypage-link-name",
                            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showAccountSidebar = false))
                          }, _toDisplayString(_ctx.$t('website.balance')), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        class: "mypage-link",
                        to: { name: 'MyPage', hash: '#Ordrer' }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: "mypage-link-name",
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showAccountSidebar = false))
                          }, _toDisplayString(_ctx.$t('website.orders')), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        class: "mypage-link",
                        to: { name: 'MyPage', hash: '#Kontooplysninger' }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: "mypage-link-name",
                            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.showAccountSidebar = false))
                          }, _toDisplayString(_ctx.$t('website.account')), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        class: "mypage-link",
                        to: { name: 'MyPage', hash: '#Modtagere' }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: "mypage-link-name",
                            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showAccountSidebar = false))
                          }, _toDisplayString(_ctx.$t('website.recipients')), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ]),
                    (_ctx.$isPartner || _ctx.$isAdmin)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_69, [
                          _createVNode(_component_router_link, {
                            class: "mypage-link",
                            to: { name: 'MyPage', hash: '#Partnerinfo' }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: "mypage-link-name",
                                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showAccountSidebar = false))
                              }, _toDisplayString(_ctx.$t('website.partner-info')), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], undefined, true),
                _: 1
              }, 8, ["visible"]),
              (_ctx.HasAnySquashSubscription)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "navigation-button",
                    onClick: _cache[32] || (_cache[32] = ($event: any) => {_ctx.showAccountSidebar = false; _ctx.$goToBookingCourts();})
                  }, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('website.book-lane')), 1)
                    ]),
                    _hoisted_71
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$isAuthorized)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    class: "menu-item",
                    to: {name: 'EventsCatalog'},
                    href: _ctx.$t('Pages.EventsCatalog.path')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.goToRouterLink('EventsCatalog')))
                      }, _toDisplayString(_ctx.$t('website.events')), 1),
                      _hoisted_72
                    ], undefined, true),
                    _: 1
                  }, 8, ["href"]))
                : _createCommentVNode("", true),
              (_ctx.$isAuthorized)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 3,
                    class: "menu-item",
                    to: {name: 'PostsCatalog'},
                    href: _ctx.$t('Pages.PostsCatalog.path')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.goToRouterLink('PostsCatalog')))
                      }, _toDisplayString(_ctx.$t('website.posts')), 1),
                      _hoisted_73
                    ], undefined, true),
                    _: 1
                  }, 8, ["href"]))
                : _createCommentVNode("", true),
              (_ctx.$isPartner || _ctx.$isAdmin)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 4,
                    class: "menu-item",
                    to: {name: 'ProductIndex'},
                    href: _ctx.$t('Pages.ProductIndex.path')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.goToRouterLink('ProductIndex')))
                      }, _toDisplayString(_ctx.$t('admin.product.products')), 1),
                      _hoisted_74
                    ], undefined, true),
                    _: 1
                  }, 8, ["href"]))
                : _createCommentVNode("", true),
              (_ctx.$isAdmin)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 5,
                    class: "menu-item",
                    to: {name: 'PostsCategoriesIndex'},
                    href: _ctx.$t('Pages.PostsCategoriesIndex.path')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.goToRouterLink('PostsCategoriesIndex')))
                      }, _toDisplayString(_ctx.$t('admin.posts.posts-categories')), 1),
                      _hoisted_75
                    ], undefined, true),
                    _: 1
                  }, 8, ["href"]))
                : _createCommentVNode("", true),
              (_ctx.$isPartner || _ctx.$isAdmin)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 6,
                    class: "menu-item",
                    to: {name: 'PostsIndex'},
                    href: _ctx.$t('Pages.PostsIndex.path')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.goToRouterLink('PostsIndex')))
                      }, _toDisplayString(_ctx.$t('admin.posts.posts')), 1),
                      _hoisted_76
                    ], undefined, true),
                    _: 1
                  }, 8, ["href"]))
                : _createCommentVNode("", true),
              (_ctx.$isPartner || _ctx.$isAdmin)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 7,
                    class: "menu-item",
                    to: {name: 'EventsIndex'},
                    href: _ctx.$t('Pages.EventsIndex.path')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.goToRouterLink('EventsIndex')))
                      }, _toDisplayString(_ctx.$t('admin.events.events')), 1),
                      _hoisted_77
                    ], undefined, true),
                    _: 1
                  }, 8, ["href"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "navigation-button",
                onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.SignOut && _ctx.SignOut(...args)))
              }, [
                _createElementVNode("div", _hoisted_78, [
                  _hoisted_79,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('website.logout')), 1)
                ]),
                _hoisted_80
              ]),
              (_ctx.$isAdmin)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 8,
                    class: _normalizeClass(["menu-item", { 'white-border': _ctx.adminCollapseVisible }]),
                    onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.adminCollapseVisible = !_ctx.adminCollapseVisible))
                  }, [
                    _hoisted_81,
                    _createElementVNode("i", {
                      class: _normalizeClass(["ico", { 'ico-arrow-down': !_ctx.adminCollapseVisible, 'ico-arrow-up': _ctx.adminCollapseVisible }])
                    }, null, 2)
                  ], 2))
                : _createCommentVNode("", true),
              _createVNode(_component_b_collapse, { visible: _ctx.adminCollapseVisible }, {
                default: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_82, [
                    _createElementVNode("li", null, [
                      (_ctx.$isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "vertical-menu-list-item",
                            to: {name: 'CategoryIndex'},
                            href: _ctx.$t('Pages.CategoryIndex.path')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.goToRouterLink('CategoryIndex')))
                              }, "Categories")
                            ], undefined, true),
                            _: 1
                          }, 8, ["href"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("li", null, [
                      (_ctx.$isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "vertical-menu-list-item",
                            to: {name: 'OrderIndex'},
                            href: _ctx.$t('Pages.OrderIndex.path')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.goToRouterLink('OrderIndex')))
                              }, _toDisplayString(_ctx.$t('admin.orders.orders')), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["href"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("li", null, [
                      (_ctx.$isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "vertical-menu-list-item",
                            to: {name: 'SubscriptionsIndex'},
                            href: _ctx.$t('Pages.SubscriptionsIndex.path')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.goToRouterLink('SubscriptionsIndex')))
                              }, _toDisplayString(_ctx.$t('admin.subscription.subscriptions')), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["href"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("li", null, [
                      (_ctx.$isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "vertical-menu-list-item",
                            to: {name: 'SubscriptionDeliveriesIndex'},
                            href: _ctx.$t('Pages.SubscriptionDeliveriesIndex.path')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.goToRouterLink('SubscriptionDeliveriesIndex')))
                              }, _toDisplayString(_ctx.$t('website.subscription-deliveries')), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["href"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("li", null, [
                      (_ctx.$isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "vertical-menu-list-item",
                            to: {name: 'MappingIndex'},
                            href: _ctx.$t('Pages.MappingIndex.path')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.goToRouterLink('MappingIndex')))
                              }, "Subscription mappings")
                            ], undefined, true),
                            _: 1
                          }, 8, ["href"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("li", null, [
                      (_ctx.$isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "vertical-menu-list-item",
                            to: {name: 'DealCode'},
                            href: _ctx.$t('Pages.DealCode.path')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.goToRouterLink('DealCode')))
                              }, _toDisplayString(_ctx.$t('admin.orders.deal-codes')), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["href"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("li", null, [
                      (_ctx.$isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "vertical-menu-list-item",
                            to: {name: 'PartnerIndex'},
                            href: _ctx.$t('Pages.PartnerIndex.path')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.goToRouterLink('PartnerIndex')))
                              }, _toDisplayString(_ctx.$t('website.partners')), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["href"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("li", null, [
                      (_ctx.$isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "vertical-menu-list-item",
                            to: {name: 'UsersInfo'},
                            href: _ctx.$t('Pages.UsersInfo.path')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.goToRouterLink('UsersInfo')))
                              }, _toDisplayString(_ctx.$t('admin.users.users')), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["href"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("li", null, [
                      (_ctx.$isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "vertical-menu-list-item",
                            to: {name: 'MessageTemplateIndex'},
                            href: _ctx.$t('Pages.MessageTemplateIndex.path')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.goToRouterLink('MessageTemplateIndex')))
                              }, _toDisplayString(_ctx.$t('website.message-templates')), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["href"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("li", null, [
                      (_ctx.$isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "vertical-menu-list-item",
                            to: {name: 'QueuedEmailIndex'},
                            href: _ctx.$t('Pages.QueuedEmailIndex.path')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.goToRouterLink('QueuedEmailIndex')))
                              }, _toDisplayString(_ctx.$t('website.queued-emails')), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["href"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("li", null, [
                      (_ctx.$isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "vertical-menu-list-item",
                            to: {name: 'ScheduleTaskIndex'},
                            href: _ctx.$t('Pages.ScheduleTaskIndex.path')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.goToRouterLink('ScheduleTaskIndex')))
                              }, _toDisplayString(_ctx.$t('website.schedule-tasks')), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["href"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("li", null, [
                      (_ctx.$isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "vertical-menu-list-item",
                            to: {name: 'Squash'},
                            href: _ctx.$t('Pages.Squash.path')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.goToRouterLink('Squash')))
                              }, _toDisplayString(_ctx.$t('website.squash-reports')), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["href"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("li", null, [
                      (_ctx.$isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "vertical-menu-list-item",
                            to: {name: 'AppTaskServiceIndex'},
                            href: _ctx.$t('Pages.AppTaskServiceIndex.path')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.goToRouterLink('AppTaskServiceIndex')))
                              }, "App Tasks")
                            ], undefined, true),
                            _: 1
                          }, 8, ["href"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], undefined, true),
                _: 1
              }, 8, ["visible"]),
              _hoisted_83,
              _createElementVNode("div", {
                onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.showAccountSidebar = false)),
                class: "overlay-sidebar"
              })
            ]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    })
  ]))
}